import Rating from '../components/Rating';
export const farmData = [
    {id:1, title:'Carrots from Tomissy Farm',
    rating:`${Rating}`, 
    desc:'Carrots from Tomissy Farm are one of the best on the market. Tomisso and his family are giving a full love to his Bio products. Tomisso’s carrots are growing on the fields naturally.',
    price:'36.23 USD', discount:'48.56 USD',
    sale:'-36%', shipping:'Free shipping',
    review:'1 customer review',
    orderNumber:'76645',
    categories:'Vegatables',
    stock:true && 'in Stock',
    farm:'Grocery Tarm Fields',
    Freshness:'1 day old',
    buying:'pcs, kgs, box, pack',
    delivery:'in 2 days',
    deliveryArea:'Czech republic',
    wishlist:'Add to my wish list',
    compare:'Compare'
}
];